import { FETCH_USERS_LIST,FETCH_DEFAULT_DATA,FETCH_VIEW_REPORT,FETCH_REWARD_REPORT,FAILD_MESSAGE } from "./type";
import * as actionFunction from "./common";

function getDefaultData(){
    var commonStateData = actionFunction.commonData()
    return (dispatch) => {
        fetch(commonStateData.apiUrl + '/employee/getdefaultdata/userAuthKey/' + commonStateData.userAuthKey, {
            method: 'POST',
            headers: {
                'Content-Encoding': 'gzip',
                'Content-Type': 'application/json'
              },
            body: JSON.stringify(commonStateData)
            }).then(response => {
                if (!response.ok) {
                  throw new Error('Network response was not ok');
                }
                return response;
            }).then(response => response.arrayBuffer()) // Get response body as ArrayBuffer
              .then(buffer => {
                const findResponse = actionFunction.decompressjsondata(buffer);
                dispatch({
                    type: FETCH_DEFAULT_DATA,
                    hr_permission: findResponse.hr_permission,
                    permissions: findResponse.permissions,
                    hiring_profile: findResponse.hiring_profile,
                    employee_id: findResponse.employee_id,
                    department_names: findResponse.department_names,
                    pod_names: findResponse.pod_names,
                    crop_names: findResponse.crop_names,
                    email_names: findResponse.group_email,
                    troop_names: findResponse.troop_names
                });
              }).catch(error => {
                console.error('There was a problem with the fetch operation:', error);
              });
    }
}
function userList(post) {
    //console.log("posts", post)
    post.page === '' ? 1 : post.page;

    var commonStateData = actionFunction.commonData()

//    console.log(13, commonStateData);
    commonStateData['page'] = post.page;
    var additional_srch = {};
    if(post !=="undefined"){
        if(post.hasOwnProperty('filter_item')){
            if(Object.keys(post.filter_item).length > 0){
                Object.keys(post.filter_item).forEach(function(key, index) {
                    additional_srch[key] = post.filter_item[key];
                });
            }
        }
    }
    commonStateData['search'] = post.search;
    commonStateData['additional_srch'] = additional_srch;
    if (commonStateData.hasOwnProperty('userEmail')) {
            delete commonStateData['userEmail'];
    }
    if (commonStateData.hasOwnProperty('studioUrl')) {
            delete commonStateData['studioUrl'];
    }
//    commonStateData['department'] = post.department
//    console.log("posts", commonStateData);
    return (dispatch) => {
//        fetch(commonStateData.apiUrl + '/HrmanagementRest/getUsers/page/' + commonStateData.page + '/userAuthKey/' + commonStateData.userAuthKey + '/userId/' + commonStateData.userId, {
        fetch(commonStateData.apiUrl + '/employee/listing/page/' + commonStateData.page + '/userAuthKey/' + commonStateData.userAuthKey + '/userId/' + commonStateData.userId, {
            method: 'POST',
//            dataType: 'json',
            headers: {
                'Content-Encoding': 'gzip',
                'Content-Type': 'application/json'
              },
            body: JSON.stringify(commonStateData)
            }).then(response => {
                if (!response.ok) {
                  throw new Error('Network response was not ok');
                }
                return response;
            }).then(response => response.arrayBuffer()) // Get response body as ArrayBuffer
              .then(buffer => {
                const findResponse = actionFunction.decompressjsondata(buffer);
                dispatch({
                    type: FETCH_USERS_LIST,
                    users: findResponse.users,
                    department_group: findResponse.department_group,
                    country_list: findResponse.country_list,
                    state_list: findResponse.state_list,
//                    city_list: findResponse.city_list,
                    item_count: findResponse.item_count,
                    pageNumber: findResponse.page_number,
                    off_count: findResponse.off_count,
                    offset: findResponse.offset,
                    hr_permission: findResponse.hr_permission
                });
              }).catch(error => {
                console.error('There was a problem with the fetch operation:', error);
              });
    }
}

function EmployeeDelete(post) {
    //console.log("posts", post)
    var commonStateData = actionFunction.commonData()
    commonStateData['id'] = post.id;
    commonStateData['search'] = post.search;
    return (dispatch) => {
//        fetch(commonStateData.apiUrl + '/HrmanagementRest/EmployeeDelete/id/' + commonStateData.id + '/userAuthKey/' + commonStateData.userAuthKey, {
        fetch(commonStateData.apiUrl + '/employee/delete/id/' + commonStateData.id + '/userAuthKey/' + commonStateData.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(post)
        })
            .then((Response) => Response.json())
            .then((findResponse) => {

                findResponse = actionFunction.decrypt(findResponse, 1);
                //console.log("new respose from actions", findResponse)
                dispatch(
                    userList(commonStateData)
                )
            });
    }
}
function EmployeeViewreport(post){
    //console.log("posts", post)
    var commonStateData = actionFunction.commonData()
    commonStateData['id'] = post.id;
    return (dispatch) => {
        fetch(commonStateData.apiUrl + '/MyPerformanceRest/ViewReport/id/' + commonStateData.id + '/userAuthKey/' + commonStateData.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(post),
        })
            .then((Response) => Response.json())
            .then((findResponse) => {

                findResponse = actionFunction.decrypt(findResponse, 1);
                //console.log("new respose from actions", findResponse)
                dispatch({
                    type: FETCH_VIEW_REPORT,
                    MyPerform_answer: findResponse.MyPerform_answer,
                    MyPerform_question: findResponse.MyPerform_question,
                    overallScore: findResponse.overallScore,
                    comment_result: findResponse.comment_result
                })

            })
    }
}
function EmployeeReward(post){
    //console.log("posts", post)
    var commonStateData = actionFunction.commonData()
    commonStateData['id'] = post.id;
    return (dispatch) => {
//        fetch(commonStateData.apiUrl + '/HrmanagementRest/EmployeeLeaveRewardDetail/id/' + commonStateData.id + '/userAuthKey/' + commonStateData.userAuthKey, {
        fetch(commonStateData.apiUrl + '/employee/leaverewarddetail/id/' + commonStateData.id + '/userAuthKey/' + commonStateData.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(post)
        })
            .then((Response) => Response.json())
            .then((findResponse) => {

//                findResponse = actionFunction.decrypt(findResponse, 1);
//                 console.log("total_reward", findResponse.total_reward)
                dispatch({
                    type: FETCH_REWARD_REPORT,
                    emp_name: findResponse.emp_detail.name,
                    emp_id: findResponse.emp_detail.id,
                    muvi_employee_id: findResponse.emp_detail.muvi_employee_id,
                    available_leaves: findResponse.available_leaves,
                    leaves_taken: findResponse.leaves_taken,
                    level: findResponse.emp_detail.level,
                    yearly_leave_label_wise: findResponse.yearly_leave_label_wise,
                    quarterly_leave_earned: findResponse.quarterly_leave_earned,
                    carry_forward_leave_earned: findResponse.carry_forward_leave_earned,
                    total_carry_forward_leave: findResponse.total_carry_forward_leave,
                    total_leave_credited: findResponse.total_leave_credited,
                    total_leave_available: findResponse.total_leave_available,
                    lop_cnt: findResponse.lop_cnt,
                    total_reward: findResponse.total_reward,
                    advance_leave: findResponse.advance_leave,
                    current_quarter: findResponse.current_quarter,
                });

            });
    }
}
function AddCreditReward(post){
//    console.log("posts", post)
    var commonStateData = actionFunction.commonData();
    return (dispatch) => {
        fetch(commonStateData.apiUrl + '/employee/creditreward/userAuthKey/' + commonStateData.userAuthKey + '/userId/' + commonStateData.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(post),
        })
            .then((Response) => Response.json())
            .then((findResponse) => {

                findResponse = actionFunction.decrypt(findResponse, 1);
//                console.log("new respose from actions", findResponse)
                    window.location.href = '/rewards';

            })
    }
}
function AddCreditLeave(post) {
    //console.log("posts", post.id)
    var commonStateData = actionFunction.commonData()
    commonStateData['id'] = post.id;
    commonStateData['leave_available'] = post.leave_available;
    return (dispatch) => {
        fetch(commonStateData.apiUrl + '/employee/creditleave/empId/' + post.id + '/leaveAvailable/' + post.leave_available + '/userAuthKey/' + commonStateData.userAuthKey+ '/userId/' + commonStateData.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(post),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {

                findresponse = actionFunction.decrypt(findresponse, 1);
                //console.log("new respose from actions", findresponse)
                    document.getElementById("credit_leave").disabled = false;
                    if (findresponse.code == 200) {
                        window.location.href = '/leaveRequests/';
                    }
                    else if (findresponse.code == 400) {
                        dispatch({
                            type: FAILD_MESSAGE,
                            registered_mail:findresponse.msg
                        })
                    }
                    else if (findresponse.code == 500) {
                        dispatch({
                            type: FAILD_MESSAGE,
                            registered_mail:findresponse.msg
                        })
                    }
                    else if (findresponse.code == 700) {
                        dispatch({
                            type: FAILD_MESSAGE,
                            registered_mail:findresponse.msg
                        })
                    }
                    else if (findresponse.code == 900) {
                        dispatch({
                            type: FAILD_MESSAGE,
                            registered_mail:findresponse.msg
                        })
                    }
                    else if (findresponse.code == 1100) {
                        dispatch({
                            type: FAILD_MESSAGE,
                            registered_mail:findresponse.msg
                        })
                    }
                   
            })
    }
}
export { userList,getDefaultData, EmployeeDelete,EmployeeViewreport,EmployeeReward,AddCreditReward,AddCreditLeave };



// WEBPACK FOOTER //
// ./src/actions/manageEmployeeAction.js